import React, { Component } from "react";
import { createSelector } from "reselect";
import { connect } from "react-redux";

class MessangerProfile extends Component {

  render() {
    const { profile, item } = this.props;

    // let image = profile && profile.avatar_id ? profile.avatar.thumb : profile.avatar;
    let image = profile && profile.avatar_id ? profile && profile.avatar && profile.avatar.thumb : profile && profile.avatar;

    return (<div className="header">
      <img src={image} className="img-fluid rounded-circle" alt="Profile Photo" />
      <h5 className="text-truncate">{profile && profile.name}</h5>
    </div>)
  }
}

const processSelector = createSelector(
  state => state.process,
  process => process
);

const messageSelector = createSelector(
  state => state.message,
  message => message
);

const authenticationSelector = createSelector(
  state => state.authentication,
  authentication => authentication
);

const mapStateToProps = createSelector(
  processSelector,
  messageSelector,
  authenticationSelector,
  (process, message, authentication) => ({
    process,
    message,
    authentication
  })
);

export default connect(mapStateToProps)(MessangerProfile);
